import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const MonthlyMagazines = () => {
  return (
    <>
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: `url('assets/img/bg/breadcumb-bg.jpg')`,
        }}
      >
        <div className="container">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">MAGAZINES</h1>
          </div>
        </div>
      </div>

      <div className="about-area overflow-hidden space" id="about-sec">
        <div className="container">
          <div className="row gy-5 justify-content-center">
            <div className="slider-wrap text-center">
              
              {/* ✅ React Swiper Component */}
              <Swiper
                modules={[Pagination]}
                pagination={{ type: "fraction" }}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  576: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  992: { slidesPerView: 2 },
                  1300: { slidesPerView: 3 },
                }}
                spaceBetween={20}
                className="serviceSlide has-shadow"
              >
                {/* Slide 1 */}
                <SwiperSlide>
                  <div className="service-block th-ani">
                    <div className="box-img global-img">
                      <img
                        src="assets/img/photo_gallery/seva/1.jpg"
                        style={{ width: "500px", height: "500px" }}
                        alt=""
                      />
                    </div>
                    <div className="box-content">
                      <div className="box-wrapp">
                        <div className="box-icon">
                          <img src="assets/img/theme-img/om4.png" alt="Icon" />
                        </div>
                        <h3 className="box-title">
                          <a href="#">
                            Sri SWAYAMPRAKASHA (Kannada) For 1 Year
                          </a>
                        </h3>
                        <p className="box-text">Price: ₹15,000.00</p>
                      </div>
                      <div className="service-btn">
                        <a href="#" className="line-btn">
                          Book Your Seva
                        </a>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>

                {/* Slide 2 */}
                <SwiperSlide>
                  <div className="service-block th-ani">
                    <div className="box-img global-img">
                      <img
                        src="assets/img/photo_gallery/seva/2.jpg"
                        style={{ width: "500px", height: "500px" }}
                        alt=""
                      />
                    </div>
                    <div className="box-content">
                      <div className="box-wrapp">
                        <div className="box-icon">
                          <img src="assets/img/theme-img/om4.png" alt="Icon" />
                        </div>
                        <h3 className="box-title">
                          <a href="#">
                            Sri SWAYAMPRAKASHA (English) For 1 Year
                          </a>
                        </h3>
                        <p className="box-text">Price: ₹15,000.00</p>
                      </div>
                      <div className="service-btn">
                        <a href="#" className="line-btn">
                          Book Your Seva
                        </a>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>

              </Swiper>
              {/* End Swiper */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MonthlyMagazines;
